import React, { useEffect } from "react";
import {
  Button,
  FlexDirectionRow,
  FormContainer,
  MainContainer,
  MainContent,
  SubTitle,
  Title,
} from "../../../../../components/StyledComponents";
import "./styles.module.scss";
import { EventoSebraeService } from "../../../services/eventoSebraeService";
import { BaSeDialogContext, BaSeIcon } from "@base/react";
import { useHistory, useParams } from "react-router-dom";
import { MdContentCopy } from "react-icons/md";
import {
  maxLength,
  minLength,
  valueIsRequired,
} from "../../../../../utils/regex";
import Input from "../../../../../components/InputControlled";
import { useForm } from "react-hook-form";
import { handleModalStatus } from "../../../../../utils/handleModalStatus";
import { UserActionsContent } from "../../../../../components/UserActionsContent";
import TextArea from "../../../../../components/TextArea";

export const EditarEventoSebrae = () => {
  const { showModal } = React.useContext(BaSeDialogContext);
  const { id } = useParams();

  const { control, handleSubmit, reset, getValues } = useForm({
    defaultValues: {},
  });

  const history = useHistory();

  const handleGoHome = () => {
    history.push("/tabelas-de-controle/EventoSebrae");
  };

  const findVersion = async () => {
    const result = await EventoSebraeService.find(id);
    if (result) {
      reset(result);
    }
  };

  useEffect(() => {
    findVersion();
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendRequest = async (dataForm) => {
    try {
      const body = { id, ...dataForm };
      await EventoSebraeService.update(body);
      handleModalStatus({
        type: "success",
        msgOnSuccess: `Evento editado com sucesso.`,
        onCloseModal: handleGoHome,
        showModal,
      });
    } catch (e) {
      handleModalStatus({
        type: "error",
        msgOnError:"Ocorreu um erro ao editar o evento. Verifique os dados e tente novamente.",
        showModal,
      });
    }
  };

  return (
    <>
      <MainContainer backgroundColor={"#0061C6"}>
        <FlexDirectionRow>
          <FlexDirectionRow style={{ width: "100%" }}>
            <MdContentCopy size={40} color="#ffffff" />
            <Title>Tabelas de Controle</Title>
          </FlexDirectionRow>
          <BaSeIcon
            onClick={handleGoHome}
            name={"arrow-circle-left"}
            description="voltar"
            color="#ffffff"
            size={50}
          />
        </FlexDirectionRow>
      </MainContainer>
      <MainContent>
        <SubTitle>
          <h3>Editar</h3>
        </SubTitle>

        <FormContainer
          style={{ displayFlex: true, flexDirection: "column" }}
          onSubmit={handleSubmit(sendRequest)}
        >
          
          <Input
            required={true}
            maxLength={100}
            minLength={3}
            name="nome"
            control={control}
            rules={{ ...valueIsRequired(), ...maxLength(100), ...minLength(3) }}
            placeholder={"Nome do Evento"}
          />

          <TextArea
            required={true}
            minLength={3}
            name="descricao"
            control={control}
            rules={{ ...valueIsRequired(), ...minLength(3) }}
            placeholder={"Descrição do Evento"}
          />

          <Input
            required={true}
            maxLength={36}
            minLength={1}
            name="codigoEvento"
            control={control}
            rules={{ ...valueIsRequired(), ...maxLength(36), ...minLength(1) }}
            placeholder={"Código do Evento (Integração)"}
          />

          <Input
            required={true}
            maxLength={255}
            minLength={10}
            name="endpoint"
            control={control}
            rules={{ ...valueIsRequired(), ...maxLength(255), ...minLength(10) }}
            placeholder={"Endpoint (Integração)"}
          />

          <Input
            required={true}
            maxLength={255}
            minLength={10}
            name="token"
            control={control}
            rules={{ ...valueIsRequired(), ...maxLength(255), ...minLength(10) }}
            placeholder={"Token (Integração)"}
          />

          <Input
            required={true}
            maxLength={1024}
            minLength={11}
            name="logo"
            control={control}
            rules={{ ...valueIsRequired(), ...maxLength(1024), ...minLength(1) }}
            placeholder={"URL - Logo do Evento"}
          />

          <Input
            required={false}
            maxLength={1024}
            name="urlInscricao"
            control={control}
            rules={{ ...maxLength(1024) }}
            placeholder={"URL - Inscrições do Evento"}
          />

          <Input
            required={false}
            name="valor"
            type="number"
            control={control}
            placeholder={"Valor Base - Inscrição"}
          />

          <Input
            required={false}
            maxLength={1024}
            name="urlMapaEvento"
            control={control}
            rules={{ ...maxLength(1024) }}
            placeholder={"URL - Mapa do Evento"}
          />

          <Input
            required={false}
            maxLength={1024}
            name="urlPontos"
            control={control}
            rules={{ ...maxLength(1024) }}
            placeholder={"URL - Programa de Pontos"}
          />

          <Input
            required={false}
            maxLength={1024}
            name="urlGaleria"
            control={control}
            rules={{ ...maxLength(1024) }}
            placeholder={"URL - Galeria"}
          />

          <Input
            required={false}
            maxLength={1024}
            name="urlSaibaMais"
            control={control}
            rules={{ ...maxLength(1024) }}
            placeholder={"URL - Saiba Mais"}
          />

          <Input
            required={false}
            maxLength={36}
            name="idComunidade"
            control={control}
            rules={{...maxLength(36) }}
            placeholder={"ID da Comunidade - REDE SEBRAE"}
          />

          <FlexDirectionRow position={"end"} style={{ marginRight: "40px" }}>
            <Button type="submit">Editar Evento</Button>
          </FlexDirectionRow>
        </FormContainer>
      </MainContent>
      <UserActionsContent data={getValues()}/>
    </>
  );
};
